import { createRouter, createWebHistory } from 'vue-router'
import Gateway from '@/onenetwork/views/Gateway.vue'
import PublicRouter from '@/onenetwork/layouts/PublicRouter.vue'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import Login from '@/onenetwork/views/auth/login.vue'
import CheckExistPhone from '@/onenetwork/views/auth/checkExistPhone.vue'
import VerifyOTP from '@/onenetwork/views/auth/verifyOTP.vue'
import ResetPW from '@/onenetwork/views/auth/resetPW.vue'
import FakeCCCD from '@/onenetwork/views/FakeCCCD.vue'


const privateRoutes = [
  {
    path: '/',
    name: 'home',
    meta: {
      component: Gateway,
      blankLayout: true
    },
    component: PrivateRouter,
  },
  {
    path: '/fake-cccd',
    name: 'fake-cccd',
    meta: {
      component: FakeCCCD,
      blankLayout: true
    },
    component: PrivateRouter,
  },
]

const publicRoutes = [
  {
    path: '/auth/login',
    name: 'auth.login',
    meta: {
      component: Login,
      blankLayout: true
    },
    component: PublicRouter,
  },
  {
    path: '/auth/forget-pw',
    name: 'auth.forget-pw',
    meta: {
      component: CheckExistPhone,
      blankLayout: true
    },
    component: PublicRouter,
  },
  {
    path: '/auth/verify-otp',
    name: 'auth.verify-otp',
    meta: {
      component: VerifyOTP,
      blankLayout: true
    },
    component: PublicRouter,
  },

  {
    path: '/auth/reset-pw',
    name: 'auth.reset-pw',
    meta: {
      component: ResetPW,
      blankLayout: true
    },
    component: PublicRouter,
  },

]

// 💡 Auto import all routes from module/*/router/index.ts
const modules = import.meta.glob('@/modules/*/router/index.ts', { eager: true })

const moduleRoutes = Object.values(modules).flatMap((mod: any) => {
  const routes = mod.default
  if (!routes || (Array.isArray(routes) && routes.length === 0)) return []

  return Array.isArray(routes) ? routes : [routes]
})

// console.log(84, [...publicRoutes, ...privateRoutes, ...moduleRoutes])

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [...publicRoutes, ...privateRoutes, ...moduleRoutes],
})


export default router
